import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWinkels = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M31 17v16H9V17zm-2-8v5H11V9z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M18 25v8h-5v-8zm9 0v5h-5v-5zm5-11v3a3 3 0 1 1-6 0 3 3 0 1 1-6 0 3 3 0 1 1-6 0 3 3 0 0 1-5.995.176L8 17v-3z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWinkels);

export default ForwardRef;
